import gsap from 'gsap'

class Menus {
    constructor() {
        this.menuBtn = document.querySelectorAll('[data-toggle-menu]')
        this.submenuToggle = document.querySelectorAll('.nav__submenu-btn')
        this.overlay = document.querySelector('#overlay')
        this.activeMenu = null
        this.activeBtn = null
        this.toggleClass = 'is-active'
        this.headerHeight()
        this.events()
    }

    events() {
        this.menuBtn.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault()
                this.menuToggle(e)
            })
        })

        this.submenuToggle.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault()
                this.toggleSubmenu(el)
            })
        })

        this.overlay.addEventListener('click', () => {
            this.closeAllMenus()
        })

        window.addEventListener('scroll', () => {
            this.headerHeight()
        })
    }

    menuToggle(e) {
        const btn = e.currentTarget
        const btnAttr = e.currentTarget.getAttribute('data-toggle-menu')
        const menu = document.querySelector('#' + btnAttr)

        if (this.activeMenu !== null && btnAttr !== this.activeMenu.id) {
            this.closeAllMenus()
        }

        if (this.activeMenu == null && btnAttr == menu.id) {
            this.openMenu(menu, btn)
        } else {
            this.closeMenu(menu, btn)
        }
    }

    openMenu(menu, button) {
        menu.style.visibility = 'visible'
        menu.classList.add(this.toggleClass)
        button.classList.add(this.toggleClass)
        button.setAttribute('aria-expanded', 'true')

        this.animateMenuIn(menu)
        this.showOverlay()

        this.activeMenu = menu
        this.activeBtn = button
    }

    closeAllMenus() {
        if (this.activeMenu) {
            this.activeMenu.classList.remove(this.toggleClass)
            this.activeBtn.classList.remove(this.toggleClass)
            this.activeBtn.setAttribute('aria-expanded', 'false')
            this.animateMenuOut(this.activeMenu)
            this.hideOverlay()
        }

        this.activeMenu = null
        this.activeBtn = null
    }

    closeMenu(menu, button) {
        menu.classList.remove(this.toggleClass)
        button.classList.remove(this.toggleClass)
        button.setAttribute('aria-expanded', 'false')
        this.animateMenuOut(menu)

        if (this.activeMenu) {
            this.hideOverlay()
        }

        this.activeMenu = null
        this.activeBtn = null
    }

    toggleSubmenu(el) {
        const panel = el.parentNode.querySelector('.nav__submenu')

        if (panel.classList.contains(this.toggleClass)) {
            panel.classList.remove(this.toggleClass)
            el.classList.remove(this.toggleClass)
            gsap.to(panel, { maxHeight: null, duration: 0.2, display: 'none' })
        } else {
            panel.classList.add(this.toggleClass)
            el.classList.add(this.toggleClass)
            panel.style.display = 'block'
            gsap.to(panel, { maxHeight: panel.scrollHeight, duration: 0.1 })
        }
    }

    showOverlay() {
        this.overlay.classList.add(this.toggleClass)
        gsap.to(this.overlay, { display: 'block', opacity: 0.3, duration: 0.5 })
    }
    hideOverlay() {
        this.overlay.classList.remove(this.toggleClass)
        gsap.to(this.overlay, { opacity: 0, display: 'none', duration: 0.5 })
    }

    animateMenuIn(menu) {
        const animationSpeed = '0.3'

        if (menu.classList.contains('slide-in-left') || menu.classList.contains('slide-in-right')) {
            gsap.to(menu, { display: 'block', x: '0%', duration: animationSpeed })
        } else if (menu.classList.contains('slide-in-down') || menu.classList.contains('slide-in-up')) {
            gsap.to(menu, { display: 'block', y: '0%', duration: animationSpeed })
        } else if (menu.classList.contains('fade-in')) {
            gsap.to(menu, { display: 'block', opacity: 1, duration: animationSpeed })
        }
    }

    animateMenuOut(menu) {
        const animationSpeed = '0.3'

        if (menu.classList.contains('slide-in-left')) {
            gsap.to(menu, { x: '100%', display: 'none', duration: animationSpeed })
        } else if (menu.classList.contains('slide-in-right')) {
            gsap.to(menu, { x: '-100%', display: 'none', duration: animationSpeed })
        } else if (menu.classList.contains('slide-in-down')) {
            gsap.to(menu, { y: '-100%', display: 'none', duration: animationSpeed })
        } else if (menu.classList.contains('slide-in-up')) {
            gsap.to(menu, { y: '100%', display: 'none', duration: animationSpeed })
        } else if (menu.classList.contains('fade-in')) {
            gsap.to(menu, { opacity: 0, display: 'none', duration: animationSpeed })
        }
    }

    headerHeight() {
        if (window.scrollY > 100) {
            document.querySelector('header').classList.add('scrolled')
        } else {
            document.querySelector('header').classList.remove('scrolled')
        }
    }
}
export default Menus
